module.exports = __webpack_public_path__ + "img/pic10.b1928e1e.png";